import { Value } from 'app/types-shared';
import { ComplexValue } from 'ui';

export interface AdministrationListContatinerState {
  query: string;
}

export interface AdministrationListContatinerProps {
  query: string;
}

export interface DefaultRoleDto {
  v: number;
  d?: string;
  ld?: string;
  disabled?: string;
  extra?: object;
}

export interface DefaultRole extends ComplexValue<number> {
  disabled?: string;
  extra?: object;
}

export enum PersonActionType {
  add = 'add',
  edit = 'edit',
  duplicate = 'duplicate'
}

export enum ExtraInfoFilterId {
  string = 'string',
  date = 'date',
  integer = 'integer',
  float = 'float',
  code = 'code'
}

export type ClearValidation = (formName: string, parameters?: {
  [key: string]: string | number;
}) => void;

export interface SubscriptionsOptions extends Value {
  rootCodes: Value[];
}
